import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "./navbar";
import Footer from "./footer";
const BASE_URL = process.env.REACT_APP_BASE_URL;
const token = window.sessionStorage.getItem("jwtToken");

const Strategies = () => {
  const [allStrategies, setAllStrategies] = useState([]);
  const [editId, setEditId] = useState(null);
  const userId = window.sessionStorage.getItem("userId");
  const [formData, setFormData] = useState({
    strategyCode: "",
    title: "",
    description: "",
    features: "",
    tag: "",
    iconURL: "",
    subscriptionStatus: 0,
    yearlyprice: "",
    monthlyprice: "",
    quarterlyprice: "",
    subscribed: false,
  });
  const [showForm, setShowForm] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 15;
  const navigate = useNavigate();

  useEffect(() => {
    fetch(`${BASE_URL}/subscription-plan/${userId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((response) => {
        const strategies = response.data?.plans || [];
        setAllStrategies(strategies);
      })
      .catch((err) => console.error("Error fetching:", err));
  }, []);

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      const formattedData = editId
        ? {
            title: formData.title,
            description: formData.description,
            subscriptionStatus: formData.subscriptionStatus,
          }
        : {
            ...formData,
            features: formData.features.split(",").map((f) => f.trim()),
          };

      const res = await fetch(
        `${BASE_URL}/strategies/update-title-description/${editId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(formattedData),
        },
      );

      if (!res.ok) throw new Error("Failed to save");

      const result = editId ? null : await res.json(); // Only parse JSON if creating new

      if (editId) {
        setAllStrategies((prev) =>
          prev.map((item) =>
            item.id === editId ? { ...item, ...formattedData } : item,
          ),
        );
      } else {
        setAllStrategies((prev) => [...prev, result]);
      }

      setFormData({
        strategyCode: "",
        title: "",
        description: "",
        features: "",
        tag: "",
        iconURL: "",
        subscriptionStatus: 0,
        yearlyprice: "",
        monthlyprice: "",
        quarterlyprice: "",
        subscribed: false,
      });
      setEditId(null);
      setShowForm(false);
      setPopupMessage(
        editId
          ? "Strategy updated successfully!"
          : "Strategy added successfully!",
      );
      setShowPopup(true);
      setTimeout(() => setShowPopup(false), 3000);
    } catch (err) {
      alert(err.message);
    }
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = allStrategies.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(allStrategies.length / itemsPerPage);

  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) pageNumbers.push(i);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <>
      <Navbar />
      <div className="main-content">
        <div className="container-fluid">
          <div
            className="d-flex justify-content-between mb-3"
            style={{ marginTop: "10px" }}
          >
            <button
              className="btn btn-primary mb-3"
              onClick={() => navigate(-1)}
            >
              Back
            </button>
            <h2 className="fw-bold">Strategies</h2>
            <h2></h2>
          </div>

          <div className="table-responsive">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>Sr No.</th>
                  <th>Strategy Code</th>
                  <th>Title</th>
                  <th>Description</th>
                  <th>Features</th>
                  <th>Tag</th>
                  <th>Icon URL</th>
                  <th>Subscription Status</th>
                  <th>Yearly Price</th>
                  <th>Monthly Price</th>
                  <th>Quarterly Price</th>
                  <th>Subscribed</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {currentItems.map((item, idx) => (
                  <tr key={idx}>
                    <td>{indexOfFirstItem + idx + 1}</td>
                    <td>{item.strategyCode}</td>
                    <td>{item.title}</td>
                    <td>{item.description}</td>
                    <td>
                      {Array.isArray(item.features)
                        ? item.features.join(", ")
                        : item.features}
                    </td>
                    <td>{item.tag}</td>
                    <td>{item.iconURL}</td>
                    <td>{item.subscriptionStatus}</td>
                    <td>{item.yearlyprice}</td>
                    <td>{item.monthlyprice}</td>
                    <td>{item.quarterlyprice}</td>
                    <td
                      style={{ cursor: "pointer", color: "blue" }}
                      onClick={() =>
                        navigate(`/strategy-user-details/${item.strategyCode}`)
                      }
                    >
                      {item.isSubscribed}
                    </td>
                    <td>
                      <button
                        className="btn btn-sm btn-secondary"
                        onClick={() => {
                          setFormData({
                            strategyCode: item.strategyCode,
                            title: item.title,
                            description: item.description,
                            features: Array.isArray(item.features)
                              ? item.features.join(", ")
                              : item.features,
                            tag: item.tag,
                            iconURL: item.iconURL,
                            subscriptionStatus: item.subscriptionStatus,
                            yearlyprice: item.yearlyprice,
                            monthlyprice: item.monthlyprice,
                            quarterlyprice: item.quarterlyprice,
                            subscribed: item.subscribed,
                          });
                          setEditId(item.id);
                          setShowForm(true);
                        }}
                      >
                        Edit
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            <nav className="d-flex justify-content-center mt-3">
              <ul className="pagination">
                <li className="page-item">
                  <button
                    className="page-link"
                    onClick={() => paginate(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    Previous
                  </button>
                </li>
                {pageNumbers.map((number) => (
                  <li key={number} className="page-item">
                    <button
                      className={`page-link ${number === currentPage ? "active" : ""}`}
                      onClick={() => paginate(number)}
                    >
                      {number}
                    </button>
                  </li>
                ))}
                <li className="page-item">
                  <button
                    className="page-link"
                    onClick={() => paginate(currentPage + 1)}
                    disabled={currentPage === pageNumbers.length}
                  >
                    Next
                  </button>
                </li>
              </ul>
            </nav>
          </div>

          {showForm && (
            <div className="modal show" style={{ display: "block" }}>
              <div className="modal-dialog" style={{ margin: "auto" }}>
                <div
                  className="modal-content"
                  style={{ backgroundColor: "#e6e8ec" }}
                >
                  <div className="modal-header">
                    <h5 className="modal-title">
                      {editId ? "Edit Strategy" : "Add Strategy"}
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => {
                        setShowForm(false);
                        setFormData({
                          strategyCode: "",
                          title: "",
                          description: "",
                          features: "",
                          tag: "",
                          iconURL: "",
                          subscriptionStatus: 0,
                          yearlyprice: "",
                          monthlyprice: "",
                          quarterlyprice: "",
                          subscribed: false,
                        });
                      }}
                    ></button>
                  </div>
                  <form onSubmit={handleSave}>
                    <div className="modal-body">
                      {[
                        ["Strategy Code", "strategyCode"],
                        ["Title", "title"],
                        ["Description", "description"],
                        ["Features", "features"],
                        ["Tag", "tag"],
                        ["Icon URL", "iconURL"],
                        ["Subscription Status", "subscriptionStatus", "number"],
                        ["Yearly Price", "yearlyprice"],
                        ["Monthly Price", "monthlyprice"],
                        ["Quarterly Price", "quarterlyprice"],
                        [
                          "Subscribed",
                          "subscribed",
                          "select",
                          ["true", "false"],
                        ],
                      ].map(([label, name, type = "text", options]) => (
                        <div
                          key={name}
                          className="mb-3 d-flex align-items-center"
                        >
                          <label
                            className="form-label me-2"
                            style={{ minWidth: "180px" }}
                          >
                            {label}
                          </label>
                          <div className="flex-grow-1">
                            {type === "select" ? (
                              <select
                                className="form-select"
                                value={formData[name]}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    [name]: e.target.value === "true",
                                  })
                                }
                                disabled={
                                  editId !== null &&
                                  name !== "title" &&
                                  name !== "description" &&
                                  name !== "subscriptionStatus"
                                }
                                required
                              >
                                {options.map((opt) => (
                                  <option key={opt} value={opt}>
                                    {opt}
                                  </option>
                                ))}
                              </select>
                            ) : (
                              <input
                                type={type}
                                className="form-control"
                                value={formData[name]}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    [name]: e.target.value,
                                  })
                                }
                                disabled={
                                  editId !== null &&
                                  name !== "title" &&
                                  name !== "description" &&
                                  name !== "subscriptionStatus"
                                }
                                required
                              />
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => {
                          setShowForm(false);
                          setFormData({
                            strategyCode: "",
                            userId: "",
                            title: "",
                            description: "",
                            features: "",
                            tag: "",
                            iconURL: "",
                            subscriptionStatus: 0,
                            yearlyprice: "",
                            monthlyprice: "",
                            quarterlyprice: "",
                            subscribed: false,
                          });
                        }}
                      >
                        Close
                      </button>
                      <button type="submit" className="btn btn-primary">
                        Save
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          )}

          {showPopup && (
            <div className="modal" style={{ display: "block" }}>
              <div className="modal-dialog">
                <div className="modal-content">
                  <div
                    className="modal-header"
                    style={{ backgroundColor: "green" }}
                  >
                    <h5 className="modal-title">Success</h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => setShowPopup(false)}
                    ></button>
                  </div>
                  <div className="modal-body">
                    <p>{popupMessage}</p>
                  </div>
                  <div className="modal-footer">
                    <button
                      className="btn btn-secondary"
                      onClick={() => setShowPopup(false)}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Strategies;
